import React, { useMemo } from "react";
import PropTypes from 'prop-types';
import { useTable } from "react-table";
import { ButtonGeneric } from "../common/ButtonGeneric";

export const ReactTable = ({headerData = [], rowsData = [], actionURI = "", idReference = null, buttonIcon = "remove_red_eye"}) => {

    // Catching the data. Purpose is to only have 1 instance.
    const memoColumns = useMemo(() => headerData, [headerData]);
    const memoData = useMemo(() => rowsData, [rowsData]);
    const memoActionURI = useMemo(() => actionURI, [actionURI]);


    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({ 
        columns: memoColumns,
        data: memoData,
    });
    
    return (
        // <table className="table table-striped table-sm scrollable-div">
        <table className="table table-sm scrollable-div">
            <thead>
                {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()} scope="col">
                        {column.render("Header")}
                    </th>
                    ))}
                </tr>
                ))}
            </thead>
            <tbody {...getTableBodyProps()}>
                {rows.map((row) => {
                prepareRow(row);
                return (
                    <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                        return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
                    })}
                    {(memoActionURI)?
                        <td>
                            <ButtonGeneric icon={buttonIcon} to={memoActionURI+ eval('row.original.'+idReference) }/>
                        </td>
                        :null
                    }
                    </tr>
                );
                })}
                
            </tbody>
        </table>
    );
    
}
export default ReactTable;

ReactTable.contextTypes = {
    t: PropTypes.func.isRequired
}
